// This file is auto-generated by @hey-api/openapi-ts

import type { Client, Options as Options2, TDataShape } from './client';
import { client } from './client.gen';
import type { GetMeData, GetMeGetConfigData, GetMeGetConfigResponses, GetMeGetRamdomRewardHistoryData, GetMeGetRamdomRewardHistoryResponses, GetMeGetTopData, GetMeGetTopResponses, GetMeResponses, GetMissionGetTopData, GetMissionGetTopResponses, GetParamByIdsData, GetParamByIdsResponses, PostMeCheckInData, PostMeCheckInResponses, PostMeClaimAccumulateRewardData, PostMeClaimAccumulateRewardResponses, PostMeClaimData, PostMeClaimMilestoneRewardData, PostMeClaimMilestoneRewardResponses, PostMeClaimResponses, PostMeContributeData, PostMeContributeResponses, PostMeShareData, PostMeShareResponses, PostMeSubmitInviteCodeData, PostMeSubmitInviteCodeResponses, PostMeUpdateMiniGameResultData, PostMeUpdateMiniGameResultResponses, PostMeUpdateShipDetailData, PostMeUpdateShipDetailResponses, PostMissionImportFishDataData, PostMissionImportFishDataResponses, PostMissionUpdateMissionStatusData, PostMissionUpdateMissionStatusResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = Options2<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * Common params
 */
export const getParamByIds = <ThrowOnError extends boolean = false>(options: Options<GetParamByIdsData, ThrowOnError>) => (options.client ?? client).get<GetParamByIdsResponses, unknown, ThrowOnError>({ url: '/param/{ids}', ...options });

export const getMe = <ThrowOnError extends boolean = false>(options?: Options<GetMeData, ThrowOnError>) => (options?.client ?? client).get<GetMeResponses, unknown, ThrowOnError>({ url: '/me', ...options });

export const getMeGetConfig = <ThrowOnError extends boolean = false>(options?: Options<GetMeGetConfigData, ThrowOnError>) => (options?.client ?? client).get<GetMeGetConfigResponses, unknown, ThrowOnError>({ url: '/me/get_config', ...options });

export const postMeContribute = <ThrowOnError extends boolean = false>(options?: Options<PostMeContributeData, ThrowOnError>) => (options?.client ?? client).post<PostMeContributeResponses, unknown, ThrowOnError>({ url: '/me/contribute', ...options });

export const postMeUpdateShipDetail = <ThrowOnError extends boolean = false>(options: Options<PostMeUpdateShipDetailData, ThrowOnError>) => (options.client ?? client).post<PostMeUpdateShipDetailResponses, unknown, ThrowOnError>({
    url: '/me/update_ship_detail',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getMeGetRamdomRewardHistory = <ThrowOnError extends boolean = false>(options?: Options<GetMeGetRamdomRewardHistoryData, ThrowOnError>) => (options?.client ?? client).get<GetMeGetRamdomRewardHistoryResponses, unknown, ThrowOnError>({ url: '/me/get_ramdom_reward_history', ...options });

export const postMeSubmitInviteCode = <ThrowOnError extends boolean = false>(options: Options<PostMeSubmitInviteCodeData, ThrowOnError>) => (options.client ?? client).post<PostMeSubmitInviteCodeResponses, unknown, ThrowOnError>({
    url: '/me/submit_invite_code',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const postMeCheckIn = <ThrowOnError extends boolean = false>(options?: Options<PostMeCheckInData, ThrowOnError>) => (options?.client ?? client).post<PostMeCheckInResponses, unknown, ThrowOnError>({ url: '/me/check_in', ...options });

export const postMeShare = <ThrowOnError extends boolean = false>(options?: Options<PostMeShareData, ThrowOnError>) => (options?.client ?? client).post<PostMeShareResponses, unknown, ThrowOnError>({ url: '/me/share', ...options });

export const postMeClaim = <ThrowOnError extends boolean = false>(options: Options<PostMeClaimData, ThrowOnError>) => (options.client ?? client).post<PostMeClaimResponses, unknown, ThrowOnError>({
    url: '/me/claim',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const postMeClaimAccumulateReward = <ThrowOnError extends boolean = false>(options: Options<PostMeClaimAccumulateRewardData, ThrowOnError>) => (options.client ?? client).post<PostMeClaimAccumulateRewardResponses, unknown, ThrowOnError>({
    url: '/me/claim_accumulate_reward',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const postMeClaimMilestoneReward = <ThrowOnError extends boolean = false>(options: Options<PostMeClaimMilestoneRewardData, ThrowOnError>) => (options.client ?? client).post<PostMeClaimMilestoneRewardResponses, unknown, ThrowOnError>({
    url: '/me/claim_milestone_reward',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const postMeUpdateMiniGameResult = <ThrowOnError extends boolean = false>(options: Options<PostMeUpdateMiniGameResultData, ThrowOnError>) => (options.client ?? client).post<PostMeUpdateMiniGameResultResponses, unknown, ThrowOnError>({
    url: '/me/update_mini_game_result',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getMeGetTop = <ThrowOnError extends boolean = false>(options: Options<GetMeGetTopData, ThrowOnError>) => (options.client ?? client).get<GetMeGetTopResponses, unknown, ThrowOnError>({ url: '/me/get_top', ...options });

export const postMissionUpdateMissionStatus = <ThrowOnError extends boolean = false>(options?: Options<PostMissionUpdateMissionStatusData, ThrowOnError>) => (options?.client ?? client).post<PostMissionUpdateMissionStatusResponses, unknown, ThrowOnError>({
    url: '/mission/update_mission_status',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Import daily FishRecord data
 *
 * Import up to 20000 full FishRecord snapshot rows after Config_FishRecord/delete_all. Each vopenid must be unique.
 */
export const postMissionImportFishData = <ThrowOnError extends boolean = false>(options?: Options<PostMissionImportFishDataData, ThrowOnError>) => (options?.client ?? client).post<PostMissionImportFishDataResponses, unknown, ThrowOnError>({
    url: '/mission/import_fish_data',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Get the top 10 fishers and the logged-in user's rank
 */
export const getMissionGetTop = <ThrowOnError extends boolean = false>(options?: Options<GetMissionGetTopData, ThrowOnError>) => (options?.client ?? client).get<GetMissionGetTopResponses, unknown, ThrowOnError>({ url: '/mission/get_top', ...options });
